export default function getPlaceThemesFactory(ajax, getSession) {
  return async function getPlaceThemes({
    placeName,
    placeId,
    theme,
    limit,
    page,
    method,
    token,
  }) {
    if (theme === 'attractions') {
      return await ajax({
        resource: `themes/${theme}?place=${placeId}&per_page=${limit}&page=${page}`,
        method,
      });
    }
    return await ajax({
      resource: `themes/${theme}?places=${placeId}&per_page=${limit}&page=${page}`,
      method,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getPlaceThemes.js